import { Box } from '@mui/material';
import React, { memo } from 'react';

import { TimeSelector } from '.';
import { DAY_DROP_DOWN_OPTIONS } from '../../utils/date';
import { Dropdown } from '../dropDowns';
import { DayTimePickerProps } from './DayTimePicker.types';

export const DayTimePicker = memo(function DayTimePickerComponent({
  onChange,
  value,
  isReversed = false,
}: DayTimePickerProps) {
  const currentDt = new Date(value || new Date());
  const onDayDropdownChange = (v: number) => {
    const currDay = currentDt.getDay();
    const newDt = new Date(currentDt.toISOString());
    newDt.setDate(currentDt.getDate() + (v - currDay));
    onChange?.(newDt.toISOString());
  };
  const onTimeSelectorChange = (v: string) => {
    const selectedHrs = new Date(v).getHours();
    const newDt = new Date(currentDt.toISOString());
    newDt.setHours(selectedHrs);
    onChange?.(newDt.toISOString());
  };
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        flexFlow: isReversed ? 'row-reverse  wrap' : `row wrap`,
        width: '100%',
      }}
    >
      <Box sx={{ flex: 1, minWidth: '5rem' }}>
        <Dropdown
          options={DAY_DROP_DOWN_OPTIONS}
          name="day-selector"
          value={currentDt.getDay()}
          onChange={onDayDropdownChange}
          sx={{ width: '100%', maxWidth: '100%', minWidth: '100%' }}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: '5rem' }}>
        <TimeSelector
          onChange={onTimeSelectorChange}
          value={currentDt.toISOString()}
          sx={{ width: '100%', maxWidth: '100%', minWidth: '100%' }}
          name="time-selector"
        />
      </Box>
    </Box>
  );
});
export default DayTimePicker;
